export type SupportedCompaniesTypes = 'apparel' | 'gamebreaker';
export type SupportedCompanyPlatforms = 'order' | 'admin';

// {{ company }}[::{{ platform }}[::{{ flags }}]]
export type PlatformTag =
    | `${SupportedCompaniesTypes}`
    | `${SupportedCompaniesTypes}::${SupportedCompanyPlatforms}`
    | string;
